import { inject, Injectable } from "@angular/core";
import { NotificationService } from "./notification-service";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ApiResponseHandlerService {
  private notificationService = inject(NotificationService);
  readonly apiFailError = "HANDLE_API_RESPONSE_MESSAGE.FAILURE_MESSAGE";
  readonly serverError = "HANDLE_API_RESPONSE_MESSAGE.SERVER_MESSAGE";
  readonly successMessage = "HANDLE_API_RESPONSE_MESSAGE.SUCCESS_MESSAGE";
  handleSuccess(status: number) {
    if (status === 200) {
      this.notificationService.showSuccess(this.successMessage);
    }
  }
  handleError(error: HttpErrorResponse): void {
    const status = error.status;
    switch (status) {
      case 400:
        this.notificationService.showError(this.apiFailError);
        break;
      case 500:
        this.notificationService.showError(this.serverError);
        break;
      default:
        this.notificationService.showError(this.apiFailError);
        break;
    }
  }
}
